<template>
	<div v-if="stationData" class="popup-content container px-0 px-md-2 mb-md-5">
		<div
			class="text-popup-content d-flex flex-column bg-white px-4 py-md-3 m-md-5 position-relative"
			style="border-radius: 20px"
		>
			<div>
				<div class="bg-white">
					<div
						class="d-flex title-2 text-grey-900 flex-row nowrap justify-content-between sticky-top bg-white py-3 mb-3 border-bottom border-gray"
					>
						<div class="popup-content-">
							{{ content.station_GoTo }} {{ stationData.name }}
						</div>
						<div
							class="d-flex align-items-start justify-content-center"
							@click.stop="handleClosePopup"
						>
							<ClsBtn :classes="'ts-x-md'" />
						</div>
					</div>
					<div
						class="popup-content-text body text-grey-900"
						v-html="infoText"
					></div>
					<div class="popup-content-text title-3 text-grey-900 py-3">
						{{ content.station_access }}
					</div>
					<div class="title-3 text-grey-900 popup-content-text">
						{{ content.station_byTheRoad }}
					</div>
					<div
						class="title-3 text-grey-900 body text-grey-900"
						v-html="stationData.route"
					></div>
					<div class="title-3 text-grey-900 popup-content-text py-3">
						{{ content.station_byTheTrain }}
					</div>
					<div class="popup-content-text" v-html="stationData.train"></div>
					<div class="title-3 text-grey-900 popup-content-text py-3">
						{{ content.station_byThePlane }}
					</div>
					<div
						class="popup-content-text body text-grey-900"
						v-html="stationData.avion"
					></div>
					<div
						v-if="stationData.pratique && stationData.pratique.length > 2"
						class="title-3 text-grey-900 popup-content-text py-3"
					>
						{{ content.station_usefulInfo }}
					</div>
					<div
						class="popup-content-text body text-grey-900"
						v-if="stationData.pratique"
						v-html="stationData.pratique"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// Components
import ClsBtn from "@/vue/common/clsBtnV2.vue";

export default {
	name: "StationPopupContent",
	props: {
		stationData: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {
		ClsBtn,
	},
	computed: {
		content() {
			return window.content;
		},
		season() {
			return window.seasonManager.season;
		},
		infoText() {
			return this.season === "H"
				? this.stationData.infoWinter
				: this.stationData.infoWSummer;
		},
	},
	methods: {
		handleClosePopup() {
			this.$emit("handleClosePopup");
		},
	},
};
</script>

<style scoped></style>
